import { useState } from "react";
import ReactFileReader from "react-file-reader";
import { useTranslation } from "react-i18next";
import SweetAlert from "sweetalert-react";
//import jschardet from 'jschardet';

import {
  downloadInvitationTemplate,
  parseInvitationCsv,
  validateAndJoinInvitationsByUser,
  downloadProfilesAndProductsList,
} from "../../helpers/csvFileHelpers";
import CreateBatchSender from "./CreateBatchSender";
import { useSelectLanguage } from "../../hooks/global/Languages";

function BatchManualInvitations({ vendor, lng, vendorLanguages, profiles, products, groups, vendorId, companyId }) {

  const { t, i18n } = useTranslation();

  const [importedInvitations, setImportedInvitations] = useState();
  const [isFile, setIsFile] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { selectTextByLanguage } = useSelectLanguage();

  const validateImportedInvitations = (invitations) => {
    if (invitations.length === 0) {
      setValidationMessage(t("err.zeroInv"));
    } else if (invitations.length > 1000) {
      setValidationMessage(t("err.invLong"));
    }
  };

  const uploadInvitationCsv = (files) => {
    setImportedInvitations(undefined);
  
    if (!files) return;
  
    if (!files[0].name.endsWith(".csv")) {
      setShowErrorMessage(true);
      setErrorMessage(t("err.wrFile"));
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = (e) => {
      try {
        const arrayBuffer = e.target.result;
        /*const uint8Array = new Uint8Array(arrayBuffer);
  
        const encodingInfo = jschardet.detect(uint8Array);
        const detectedEncoding = encodingInfo.encoding === 'ascii' ? 'UTF-8' : (encodingInfo.encoding || 'UTF-8');
        console.log('Detected Encoding:', detectedEncoding);*/
  
        let decoder = new TextDecoder('UTF-8');
        let rows = decoder.decode(arrayBuffer);
  
        // Check for replacement character to indicate potential misinterpretation
        if (rows.includes('\uFFFD')) {
          console.log('Detected replacement characters, retrying with windows-1252');
          decoder = new TextDecoder('windows-1252');
          rows = decoder.decode(arrayBuffer);
        }

  
        parseInvitationCsv(rows, (invitationRows) => {
          let invitations = validateAndJoinInvitationsByUser(
            invitationRows,
            products,
            groups,
            profiles,
            vendorId,
            companyId,
            vendorLanguages,
            vendorLanguages,
            t
          );
  
          setIsFile(true);
  
          if (!invitations) return;
  
          setImportedInvitations(invitations);
          validateImportedInvitations(invitations);
        });
      } catch (error) {
        console.error('Error processing file:', error);
        setShowErrorMessage(true);
        setErrorMessage(t("err.wrFile"));
      }
    };
  
    reader.onerror = () => {
      console.error('FileReader error:', reader.error);
      setShowErrorMessage(true);
      setErrorMessage(t("err.wrFile"));
    };
  
    // Read the file as an ArrayBuffer
    reader.readAsArrayBuffer(files[0]);
  };
  

  const removeImportedInvitation = (invitationEmail, profileId) => {
    let newInvitationsList = [...importedInvitations];
    let inviteToKeep = newInvitationsList.filter(
      (invite) =>
        !(
          invite.customerEmail === invitationEmail &&
          invite.profileId === profileId
        )
    );
    setImportedInvitations(inviteToKeep);
  };

  const notifyError = (err) => {
    setErrorMessage(err);
    showErrorMessage(true);
  };

  return (
    <div>
      <SweetAlert
        show={showErrorMessage}
        title={t("err.warn")}
        type="warning"
        text={errorMessage}
        confirmButtonText="Ok"
        onConfirm={() => setShowErrorMessage(false)}
      />

      <h2>
        {t("admin.inv.inU")}
        <span className="mail"></span>
      </h2>
      <div className="clearfix">
        <ul className="instructionsList">
          <li>
            {t("admin.inv.tmpU")}
            <a className="link link-csvDownload" href="#" onClick={() => downloadInvitationTemplate(vendorLanguages, t)} >
              &nbsp;{t("admin.common.here")}
            </a>
            .
          </li>
          <li>
            {t("admin.inv.ele")}
            <a className="link link-csvDownload" href="#" onClick={() =>
                downloadProfilesAndProductsList( groups, profiles, products, vendor, vendorLanguages,t, i18n.language, selectTextByLanguage )}
>
              &nbsp;{t("admin.common.here")}
            </a>
            .
          </li>
          <li>{t("admin.inv.csv")}</li>
        </ul>
        <div className="clearfix">
          <ReactFileReader handleFiles={uploadInvitationCsv} fileTypes={".csv"}>
            <p>
              <a className="link link-csvUpload" title={t("admin.inv.upl")}>
                {t("admin.inv.upl")}
              </a>
            </p>
          </ReactFileReader>
        </div>
      </div>
      {isFile && (
        <div>
          {validationMessage ? (
            <div>
              <h4 className="warning margin-top-n20">
                <i className="fa fa-warning" aria-hidden="true"></i>{" "}
                {validationMessage}
              </h4>
              <div className="text-center buttonWrap">
                <ReactFileReader handleFiles={uploadInvitationCsv} fileTypes={".csv"}>
                  <a className="link link-csvUpload" title={t("admin.inv.reUp")}>
                    {t("admin.inv.reUp")}
                  </a>
                </ReactFileReader>
              </div>
            </div>
          ) : (
            <div>
              <p>
                <strong>{t("admin.inv.recInv")}</strong>
              </p>
              <CreateBatchSender
                profiles={profiles}
                vendor={vendor}
                importedInvitations={importedInvitations}
                notifyError={notifyError}
                removeImportedInvitation={removeImportedInvitation}
                uploadInvitations={uploadInvitationCsv}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default BatchManualInvitations;
